import clsx from 'clsx'
import { OdinIcon } from '@/components/ui/odin/odin-icon'
import { useToggleWidget } from 'hooks/useToggleWidget'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import { useGetSetting } from 'api/settings'

export const WidgetHelpMessage = () => {
  const isWidgetOpened = useToggleWidget()
  const { t } = useTranslation()
  const { setting } = useGetSetting()
  const [showHelpMessage, setShowHelpMessage] = useState(false)
  const hasShownRef = useRef(false)

  useEffect(() => {
    if (hasShownRef.current) return
    const timer = setTimeout(() => {
      if (!isWidgetOpened && setting?.portal?.helpPopupVisible !== false) {
        setShowHelpMessage(true)
        hasShownRef.current = true
      }
    }, 1500)
    return () => clearTimeout(timer)
  }, [setting, isWidgetOpened])

  useEffect(() => {
    if (isWidgetOpened && showHelpMessage) {
      setShowHelpMessage(false)
    }
  }, [isWidgetOpened, showHelpMessage])

  if (showHelpMessage) {
    return (
      <div
        className={clsx(
          'animate-slide-up-bounce fixed right-4 bottom-20 rounded-xl border border-primary bg-background p-2 text-sm',
        )}
      >
        <div className="font-bold text-primary">
          <span className={'mr-[3px]'}>{t('needHelp')}</span>
          <OdinIcon icon={['fas', 'question-circle']} className="text-sm" />
        </div>
      </div>
    )
  }

  return null
}
